export const PMSStatus = {
  PENDING: 'Pending',
  AT_WORK: 'In operation',
  PAUSED: 'Paused',
  TERMINATED: 'Terminated',
};

export const PMSStatusEnum = {
  PENDING: 'PENDING',
  AT_WORK: 'AT_WORK',
  PAUSED: 'PAUSED',
  TERMINATED: 'TERMINATED',
};
